<template>
    <div class="union-title-container">
        <div v-if="unionTitle.key" class="union-key">
            {{ formatedKey }}
        </div>
        <div ref="title" class="title">
            <div class="union-title" v-html="$t(unionTitle.title)" />
            <div ref="target" class="arrows-donghua">
                <div ref="arrowSvg" class="unique-svg">
                    <CommonComponentsSVGSolutionsArrowGreen />
                </div>
                <div
                    v-if="unionTitle.subTitle && typeof unionTitle.subTitle === 'string'"
                    ref="titleTwo"
                    class="union-title-two"
                >
                    {{ $t(unionTitle.subTitle) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { gsap } from 'gsap';
    import { ScrollTrigger } from 'gsap/all';
    gsap.registerPlugin(ScrollTrigger);

    const props = defineProps<{
        unionTitle: UnionTitle;
    }>();

    const data = reactive({});
    const title = ref(null);
    // const target=ref(null)
    const arrowSvg = ref(null);
    const titleTwo = ref(null);

    onMounted(() => {
        // 1、效果1 ：两种
        gsap.timeline({
            scrollTrigger: {
                // markers: { startColor: 'green', endColor: 'red', fontSize: '12px' },
                trigger: title.value,
                scrub: true,
                start: 'top bottom-=80px',
                end: 'bottom 65%',
            },
        })
            .fromTo(
                arrowSvg.value,
                {
                    webkitClipPath: 'inset(0%  100% 0% 0%)',
                },
                {
                    webkitClipPath: 'inset(0%  0% 0% 0%)',
                },
            )
            .fromTo(
                titleTwo.value,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 0.5,
                },
            );

        // 2、效果2 :每个都竖着出现
        // gsap.fromTo(target.value,{
        //         // scale: 0.8,
        //         webkitClipPath: 'inset(0%  100% 0% 0%)',

        //     }, {
        //         // scale: 1,
        //         webkitClipPath: 'inset(0%  0% 0% 0%)',
        //         duration: 1,
        //         scrollTrigger: {
        //             markers: { startColor: 'green', endColor: 'red', fontSize: '12px' },
        //             trigger: title.value,
        //             scrub: true,
        //             // start: 'top bottom-=80px',
        //             start: 'top bottom',
        //             end: 'bottom 65%',
        //         }
        //     })
    });
    const formatedKey = computed(() =>
        typeof props.unionTitle.key === 'number' ? `0${props.unionTitle.key}` : props.unionTitle.key,
    );
</script>

<style lang="less" scoped>
    .union-title-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .title,
        .arrows-donghua {
            display: flex;
            justify-content: center;
            align-items: center;
            // flex-direction: column;
        }
        .title {
            margin-top: .convert(16px) [ @vw];
            margin-bottom: .convert(40px) [ @vw];
            height: .convert(16px) [ @vw];
        }
        .union-key {
            width: fit-content;
            font-size: .convert(@font-size-title-xxl) [ @vw]; //96px
            font-family: 'NeuePowerW05-Bold';
            font-weight: @font-weight-xl;
            line-height: 100%;
            @media (max-width: @screen-mobile-width) {
                font-size: .convert(@font-size-title-xs) [ @vw-mobile] !important; //36px
                margin-bottom: .convert(10px) [ @vw-mobile] !important; //10px;
                // margin-top: .convert(40px) [ @vw-mobile] !important; //10px;
            }
        }

        .union-title,
        .union-title-two {
            width: fit-content;
            font-size: .convert(@font-size-title) [ @vw]; //48px
            line-height: 120%;
            text-align: center;
            margin-top: .convert(16px) [ @vw];
            @media (max-width: @screen-mobile-width) {
                font-size: .convert(@font-size-lg-ssm) [ @vw-mobile] !important; //16px
            }
        }
        .unique-svg {
            width: .convert(144px) [ @vw];
            transform: translateY(.convert(10px) [ @vw];);
            margin: auto .convert(40px) [ @vw];
            display: flex;
            img {
                width: 100%;
                // margin-top: ;
                @media (max-width: @screen-mobile-width) {
                    margin-top: .convert(-4px) [ @vw-mobile];
                }
            }
        }
    }
</style>
